import React from 'react';
import { AuthenticationCheck } from '@jira/spa-apps__common/src/AuthenticationCheck.tsx';
import { SpaStatePageReady } from '@atlassian/jira-spa-state-controller/src/components/main.tsx';
import UFOSegment from '@atlassian/jira-ufo-segment/src/index.tsx';
import RouteWrapperListPage from './AdministrationList.tsx';

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
const ListPage = (props: Record<any, any>): React.JSX.Element => (
	<UFOSegment name="applinks-administration-list-page">
		<AuthenticationCheck>
			<RouteWrapperListPage {...props} />
			<SpaStatePageReady />
		</AuthenticationCheck>
	</UFOSegment>
);

export default ListPage;
